import api from '@/api'

// State（状態）
// https://next.vuex.vuejs.org/ja/guide/state.html
// 状態を監視するデータ
const state = () => ({
  data: {},
  list: [],
})

// Getters（算出プロパティ）
// https://next.vuex.vuejs.org/ja/guide/getters.html
// コンポーネントから状態を取得するプロパティまたは関数
const getters = {
  results: (state) => state.data.results,
  prev: (state) => state.data.previous,
  next: (state) => state.data.next,
  list: (state) => state.list,
}

// Mutations（状態変更）
// https://next.vuex.vuejs.org/ja/guide/mutations.html
// 状態を変更するメソッド
const mutations = {
  setData: (state, data) => (state.data = data),
  clearData: (state) => (state.data = []),
  setList: (state, list) => (state.list = list),
  clearList: (state) => (state.list = []),
}

// Actions（処理）
// https://next.vuex.vuejs.org/ja/guide/actions.html
// コンポーネントからミューテーションを実行する関数
const actions = {
  clearAll({ commit }) {
    return new Promise((resolve) => {
      commit('clearData')
      commit('clearList')
      resolve()
    })
  },
  /**
   * 一覧データを取得する
   *
   * @param {object} queryParams
   * @return {object}
   */
  async fetchAll({ commit }, queryParams) {
    const response = await api.get('manage/inspection/interrupted-reasons/', {
      params: queryParams,
    })
    commit('setData', response.data)
  },
  /**
   * リストデータを取得する
   *
   * @param {object} queryParams
   * @return {object}
   */
  async fetchList({ commit }, queryParams) {
    const response = await api.get(
      'manage/inspection/interrupted-reasons/list/',
      {
        params: queryParams,
      }
    )
    // response.data の key をすべて変更してセットする
    commit(
      'setList',
      response.data.map((item) => {
        return {
          value: item.id,
          name: item.reason,
        }
      })
    )
  },
  /**
   * データを追加する
   *
   * @param {object} formData
   * @return {object}
   */
  async postData({ state }, formData) {
    const response = await api.post(
      'manage/inspection/interrupted-reasons/',
      formData
    )
    state.data.results.push(response.data)
  },
  /**
   * データを更新する
   *
   * @param {object} formData
   * @return {object}
   */
  async patchData({ state }, formData) {
    const response = await api.patch(
      `manage/inspection/interrupted-reasons/${formData.id}/`,
      formData
    )

    const target = state.data.results.find(
      (result) => result.id === formData.id
    )
    if (target) {
      Object.assign(target, response.data)
    }
  },
  /**
   * データを作成または更新する
   *
   * @param {object} formData
   * @return {object}
   */
  async postOrPatch({ dispatch }, formData) {
    const requiredKeys = ['id', 'reason', 'is_active']
    const submitData = Object.fromEntries(
      Object.entries(formData).filter(([key]) => requiredKeys.includes(key))
    )

    if (Object.keys(submitData).length === 0) {
      console.warn('送信データが空です')
      return
    }

    return submitData.id
      ? dispatch('patchData', submitData)
      : dispatch('postData', submitData)
  },
  /**
   * データを削除する
   *
   * @param {number} id
   * @return {void}
   */
  async deleteData({ state }, id) {
    await api.delete(`manage/inspection/interrupted-reasons/${id}/`)

    const index = state.data.results.findIndex((result) => result.id === id)
    if (index !== -1) {
      state.data.results.splice(index, 1)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
